// IDI-226: the dealer's paid_seats is the one seat number. The settings Lambda
// refuses a new Paid seat past it with a 422 and writes nothing (D3).
export const NO_PAID_SEATS_MSG = 'No paid seats available. Free a seat or ask IDI to add one.';
export const isNoPaidSeatsError = (err) => (err?.response?.status ?? err?.status) === 422;
